/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './settings';
import {polyfill} from "seamless-scroll-polyfill";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {dispatchCustomEvent} from '@dvrd/dvr-controls';
import * as Sentry from '@sentry/react';

declare global {
    interface Window {
        log: Function;
        mode: string;
        settings: Record<string, any>;
        modeSettings: { [index: string]: any };
        dce: Function;
        allowCookies: boolean;
        dataLayer: any;
        gtag?: Function;
    }
}

if (window.mode === 'prod')
    Sentry.init({dsn: "https://c397a27d704747f59b1408f099abf3db@o215057.ingest.sentry.io/5339013"});

polyfill();
window.dce = (event: string, data?: any) => {
    dispatchCustomEvent(event, data);
};